import {Injectable} from "@angular/core";
import {LanguageProvider} from "./language-provider";
import {LocalizationsProvider} from "./localizations-provider";
import {LocalizationStrings} from "./i18n-model";

@Injectable()
export class I18nService {
  constructor(
    private readonly languageProvider: LanguageProvider,
    private readonly localizationsProvider: LocalizationsProvider
  ) {
  }

  getLocalizedString(key: keyof LocalizationStrings, languageString: string | undefined = undefined): string {

    const overrideReportLanguage = shouldIgnoreReportLanguageForKey(key);
    const localizations = this
      .localizationsProvider
      .getLocalizations()
      .get(
        languageString
        || this.languageProvider.getLanguage(overrideReportLanguage)
      );

    if (localizations === undefined) {
      return key;
    }

    return localizations[key] || key;
  }
}

export function shouldIgnoreReportLanguageForKey(key: keyof LocalizationStrings): boolean {

  const regex = /^navigation|^footer|Button|^changePasswordLabel$|^changeLanguageLabel$|^analysisMessage/;

  return regex.test(key);
}
